import React, { Component } from 'react';
import { Image, Picture } from 'pixboost-react';
import pixboostConfig from '../../../config/pixboost';
import './Tile.css';
import Cta from '../Cta/Cta';
import { linkHandler } from '../../../utils/urlUtils';
import classNames from 'classnames';
import Icon from '../../Icon';

class Tile extends Component {
  render() {
    if (!this.props.contentBlock || !this.props.storeConfig) {
      return null;
    }

    const {
      title,
      image,
      link,
      links,
      buttonText,
      ctaPosition,
      ctaMobilePosition,
      isResponsiveImage,
      isFullWidthImage,
      description,
      titleFontSize,
      backgroundColour,
      linkTag,
      viewAll
    } = this.props.contentBlock;

    const { imageBasePath } = this.props.storeConfig;

    const { onClickHandler, className } = this.props;

    const isSvgImage = image && image.indexOf('#') >= 0;

    const classes = classNames('tile', className, {
      [backgroundColour]: backgroundColour,
      'full-width-image': isFullWidthImage,
      'has-link': link || onClickHandler,
      'has-button-text': buttonText,
      'view-all': viewAll
    });

    const inlineStyles = viewAll
      ? {
          backgroundImage: `url(${imageBasePath}${image})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          backgroundColour: 'transparent'
        }
      : null;

    return (
      <div style={inlineStyles}>
        <div
          className={classes}
          title={title}
          onClick={e => {
            linkHandler(
              link,
              linkTag,
              e,
              onClickHandler,
              this.props.contentBlock
            );
          }}
          style={{ cursor: link || onClickHandler ? 'pointer' : '' }}
        >
          <div>
            {viewAll && (
              <div className={'icon'}>
                <Icon
                  name="components--slider--chevron-inverted"
                  width="30"
                  height="30"
                  color={'#005bab'}
                  className={'icon'}
                />
              </div>
            )}
            <Cta
              title={title}
              buttonText={buttonText}
              ctaPosition={ctaPosition}
              ctaMobilePosition={ctaMobilePosition}
              link={link}
              links={links}
              description={description}
              titleFontSize={titleFontSize}
              linkTag={linkTag}
            />
          </div>
          {image && (
            <div>
              {isSvgImage ? (
                <div className="image">
                  <svg>
                    <use xlinkHref={image} />
                  </svg>
                </div>
              ) : (
                <div className="image">
                  {isResponsiveImage ? (
                    <Picture
                      alt={title}
                      breakpoints={{
                        lg: {
                          src: imageBasePath + image.lg
                        },
                        md: {
                          src: imageBasePath + image.md
                        },
                        sm: {
                          src: imageBasePath + image.sm
                        }
                      }}
                      config={pixboostConfig}
                    />
                  ) : (
                    <Image
                      src={imageBasePath + image}
                      alt={title}
                      config={pixboostConfig}
                      op={'resize?size=x400'}
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

Tile.defaultProps = {
  lazy: true
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Tile/Tile.js